<template>
  <div class="error">
    <div class="error__icon">
      <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M3.75,10.747V17.5a3,3,0,0,0,3,3h10.5a3,3,0,0,0,3-3v-.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M20.25,13.747V7a3,3,0,0,0-3-3H6.75a3,3,0,0,0-3,3v.75" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M6.75 13.747L3.75 10.747 0.75 13.747" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M17.25 10.747L20.25 13.747 23.25 10.747" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M12 7.021L12 13.021" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M12,16.4a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,16.4h0" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>
    </div>

    <h1>Seite nicht gefunden</h1>

    <p>Diese Seite konnte nicht gefunden werden. Sie können aber:</p>

    <ul>
      <li>die <a href="/">Startseite</a> aufrufen</li>
      <li>unsere <router-link :to="cLink('/fertige')">fertigen Präsente</router-link> ansehen</li>
      <li>ein Präsent <router-link :to="cLink('/zusammenstellen')">individuell erstellen</router-link></li>
    </ul>

    <p class="u-text-muted"><small>Wenn Sie glauben, dass dies ein Fehler ist, <a href="https://componata.de/kontakt/" style="text-decoration: underline;">kontaktieren Sie uns</a> bitte.</small></p>
  </div>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';

export default {
  name: 'Error',
  mixins: [logicMixin],
};
</script>

<style lang="scss" scoped>
/**
 * Error page
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Error page for http status codes
 * @since 2021-08-17
**/

$component: 'error';

.#{$component} {
  @include padding(map-get($spacers, 6) 30%);
  color: $ink-lighter;
  text-align: center;

  &__icon {
    display: block;
    width: 128px;
    @include margin(0 auto map-get($spacers, 4));
    color: $ink-lightest;
  }

  ul {
    @include unlist;
    @include margin-bottom(map-get($spacers, 3));

    li:not(:first-child) {
      @include margin-top(map-get($spacers, 1));
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
    @include padding(map-get($spacers, 6) 0%);
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {

  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
